import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/common.json";
import fa from "./locales/fa/common.json";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            fa: { translation: fa }
        },
        fallbackLng: "fa",
        interpolation: {
        escapeValue: false
    }
});

// کنترل RTL | LTR
i18n.on("languageChanged", (lng) => {
    document.documentElement.dir = lng === "fa" ? "rtl" : "ltr";
    document.documentElement.lang = lng;

    const fontValue = lng === "fa" 
        ? "'Vazir', Arial, sans-serif"
        : "'Lato', Arial, sans-serif";

    document.documentElement.style.setProperty('--font-family-base', fontValue);
});

export default i18n;
